import React from 'react';
var ListContext = /*#__PURE__*/React.createContext({
  bordered: false,
  size: 'md'
});
export default ListContext;